export default __webpack_public_path__ + "media/zurb/img/party/zurbwired-5f87f54992b050e69790983f72891107.png";